import { ReactNode } from 'react';

import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Button } from 'components/Button/styles';

import * as S from './style';

import { ForwardAlertUnavailableProps } from './types';

const ForwardUnavailableByGeoCode: React.FC<ForwardAlertUnavailableProps> = ({
  confirmedCriticality,
}) => {
  const handleConfirmedCriticality = () => {
    confirmedCriticality();
  };

  return (
    <>
      <S.DrawerContentTitleUnavailable>
        <FormattedMessage id="CPPLATFORM.CONFIRMEDCRITICALITYITALY.TITLE" />
      </S.DrawerContentTitleUnavailable>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '80%',
        }}
      >
        <S.DrawerContentSubTitle>
          <FormattedMessage
            id="CPPLATFORM.CONFIRMEDCRITICALITYITALY.SUBTITLE"
            values={{
              b: (chunks: ReactNode[]) => (
                <Typography display="inline" fontWeight="medium">
                  {chunks}
                </Typography>
              ),
            }}
          />
        </S.DrawerContentSubTitle>

        <S.DrawerBoxFooter>
          <Button onClick={handleConfirmedCriticality}>
            <FormattedMessage id="CPPLATFORM.CONFIRMEDCRITICALITYITALY.BUTTON" />
          </Button>
        </S.DrawerBoxFooter>
      </Box>
    </>
  );
};

export default ForwardUnavailableByGeoCode;
